import { type FC } from 'react'
import { Header } from '../Header/Header'
import { type HeaderProps } from '../Header/Header.interface'
import { Footer } from '../Footer/Footer'
import { type FooterProps } from '../Footer/Footer.interface'
import { type BusinessFinderProps } from '../BusinessFinder/BusinessFinder.interface'
import { type CookieBannerProps } from '../Cookies/CookieBanner/CookieBanner.interface'
import { CookieBannerHiddenOnEditor } from '../Cookies/CookieBanner/CookieBanner'
import styles from './Layout.module.scss'

export interface LayoutLayoutProps {
  header: HeaderProps;
  footer: FooterProps;
  noFooter?: boolean;
  cookies: CookieBannerProps;
}

export interface LayoutProps {
  children: React.ReactNode;
  layout: LayoutLayoutProps;
  businessFinder: BusinessFinderProps;
  altCTA?: boolean;
  pinkHeader?: boolean;
}

export const Layout: FC<LayoutProps> = ({
  layout,
  businessFinder,
  altCTA,
  pinkHeader,
  children
}) => (
  <div className={styles.container}>
    <Header
      searchText={layout.header.searchText}
      cta={layout.header.cta}
      pink={pinkHeader ?? false}
      ctaActive={layout.header.ctaActive}
      searchOverlay={businessFinder}
      altCTA={altCTA ?? false}
    />
    {children}
    {!layout.noFooter && (
    <Footer
      copyrightText={layout.footer.copyrightText}
      footerLinks={layout.footer.footerLinks}
      siteByLabel={layout.footer.siteByLabel}
      siteByLink={layout.footer.siteByLink}
    />
    )}
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <CookieBannerHiddenOnEditor {...layout.cookies} />
  </div>
)
